export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/1376265d92690fd518e46d698aec8208.png";